<template>
  <div>
    <div class="tile">
      <div class="form-inline">
        <b-form-input type="month" v-model="period" class="mr-1" @change="load"></b-form-input>
        <button @click="load" class="btn btn-primary mr-1">{{ $t('search') }}</button>
      </div>
    </div>

    <div class="tile">
      <div class="table-responsive c-template-table">
        <table class="table table-hover table-bordered text-center">
          <caption class="text-center text-uppercase font-weight-bold" style="caption-side: top; color: #000;">
            {{ $t('reportTitle') }} {{ monthLabel }}
          </caption>
          <thead>
          <tr>
            <th>{{ $t('stt') }}</th>
            <th>{{ $t('fullName') }}</th>
            <th>{{ $t('position') }}</th>
            <th>{{ $t('kpiForCommission') }}</th>
            <th>{{ $t('callFeeUnder12', [monthLabel]) }}</th>
            <th>{{ $t('commissionPercent') }}</th>
            <th>{{ $t('callFeeOver12Big') }}</th>
            <th>{{ $t('commissionPercent') }}</th>
            <th class="text-danger">{{ $t('commissionReceived') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in rows" :key="item.userId">
            <td>{{ index + 1 }}</td>
            <td>{{ item.name }}</td>
            <td>{{ position(item.role) }}</td>
            <td>{{ item.kpiBracket }}</td>
            <td class="text-right">{{ item.feeUnder12 | numFormat }}</td>
            <td>{{ percent(item.pctUnder12) }}</td>
            <td class="text-right">{{ item.feeOver12Big | numFormat }}</td>
            <td>{{ percent(item.pctOver12Big) }}</td>
            <td class="text-right font-weight-bold text-danger">
              <span v-if="item.commission > 0">{{ item.commission | numFormat }}</span>
              <span v-else>-</span>
            </td>
          </tr>
          <tr v-if="!rows.length">
            <td colspan="9" class="text-danger">{{ $t('noData') }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      period: moment().format('YYYY-MM'),
      items: [],
    }
  },
  computed: {
    monthLabel() {
      return moment(this.period, 'YYYY-MM').format('MM/YYYY');
    },
    rows() {
      // Sắp xếp: khu vực (VP Miền Bắc trước), trong khu vực theo hoa hồng giảm dần
      return [...this.items].sort((a, b) => {
        let office = (a.office || '').localeCompare(b.office || '');
        if (office !== 0) {
          return office;
        }
        return b.commission - a.commission;
      });
    }
  },
  methods: {
    load() {
      let [year, month] = this.period.split('-');
      let loader = this.$loading.show();
      this.$service.get('/report/call-fee-commission', {
        params: {month: parseInt(month), year: parseInt(year)}
      }).then(response => {
        this.items = response.data;
      }).finally(() => {
        loader.hide();
      });
    },
    percent(value) {
      return (value || 0).toFixed(2) + '%';
    },
    position(role) {
      const map = {
        supervisor: this.$t('roleSupervisor'),
        manager: this.$t('roleManager'),
      };
      return map[role] || this.$t('roleConsultant');
    }
  },
  mounted() {
    this.load();
  },
  i18n: {
    messages: {
      en: {
        reportTitle: 'Call fee month',
        stt: 'No.',
        fullName: 'Full name',
        position: 'Position',
        kpiForCommission: 'KPI for commission',
        callFeeUnder12: 'Call fee {0} (customers under 12 months)',
        callFeeOver12Big: 'Call fee customers >15 users, >12 months',
        commissionPercent: '% Commission',
        commissionReceived: 'Commission received',
        roleConsultant: 'Consultant',
        roleSupervisor: 'Supervisor',
        roleManager: 'Manager',
        noData: 'No KPI data for this month',
      },
      vi: {
        reportTitle: 'Cước gọi tháng',
        stt: 'STT',
        fullName: 'Họ tên',
        position: 'Chức vụ',
        kpiForCommission: 'KPI tính hoa hồng',
        callFeeUnder12: 'Cước gọi tháng {0} (khách hàng dưới 12 tháng)',
        callFeeOver12Big: 'Cước gọi khách hàng >15 user, >12 tháng',
        commissionPercent: '% Hoa hồng nhận',
        commissionReceived: 'Hoa hồng nhận được',
        roleConsultant: 'Nhân viên tư vấn',
        roleSupervisor: 'Trưởng nhóm',
        roleManager: 'Quản lý',
        noData: 'Chưa có dữ liệu KPI cho tháng này',
      }
    }
  }
}
</script>

<style scoped>
.c-template-table table.table thead th {
  background-color: #f2f2f2 !important;
}
</style>
